import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import './index.css';
import App from './App';
import { msalInstance } from './config/msalConfig';
import reportWebVitals from './reportWebVitals';

const originalFetch = window.fetch.bind(window);
window.fetch = (input, init = {}) => {
  const auditType = localStorage.getItem('audit_type');
  if (!auditType) {
    return originalFetch(input, init);
  }

  const isRequestObject = typeof Request !== 'undefined' && input instanceof Request;
  const requestUrl = isRequestObject ? input.url : String(input || '');
  const isApiCall = requestUrl.includes('/api/');
  if (!isApiCall) {
    return originalFetch(input, init);
  }

  const headers = new Headers(isRequestObject ? input.headers : (init.headers || {}));
  if (!headers.has('X-Audit-Type')) {
    headers.set('X-Audit-Type', auditType);
  }

  if (isRequestObject) {
    const wrappedRequest = new Request(input, { ...init, headers });
    return originalFetch(wrappedRequest);
  }

  return originalFetch(input, { ...init, headers });
};

const root = ReactDOM.createRoot(document.getElementById('root'));

msalInstance.initialize().then(() => {
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
